export class LeadershipTeamVisit {
    id!: string
    indexId!: number
    job!: string
    visitDate!: Date
    visitedByUserId!: string
    notes!: string
    observations!: string
    safetyFeedback!: string
    cumulativeLaborHoursAtVisit?: number
    archived!: boolean
    createdOn!: Date
    createdByUserId?: string
    jobName!: string
    visitedByName!: string
    imageUrls: string[] = []

    static createNew(): LeadershipTeamVisit {
        const visit = new LeadershipTeamVisit()
        visit.id = crypto.randomUUID()
        visit.visitDate = new Date()
        visit.job = ''
        visit.visitedByUserId = ''
        visit.notes = ''
        visit.observations = ''
        visit.safetyFeedback = ''
        visit.archived = false
        visit.imageUrls = []
        return visit
    }
}

export interface LeadershipTeamMember {
    id: string
    displayName: string
    emailAddress: string
}
